var firstName = ["Adam", "Alex", "Aaron", "Ben", "Carl", "Dan", "David", "Edward", "Fred", "Frank", "George", "Hal", "Hank", "Ike", "John", "Jack", "Joe", "Larry", "Monte", "Matthew", "Mark", "Nathan", "Otto", "Paul", "Peter", "Roger", "Roger", "Steve", "Thomas", "Tim", "Ty", "Victor", "Walter"] 
var lastName = ["Anderson", "Ashwoon", "Aikin", "Bateman", "Bongard", "Bowers", "Boyd", "Cannon", "Cast", "Deitz", "Dewalt", "Ebner", "Frick", "Hancock", "Haworth", "Hesch", "Hoffman", "Kassing", "Knutson", "Lawless", "Lawicki", "Mccord", "McCormack", "Miller", "Myers", "Nugent", "Ortiz", "Orwig", "Ory", "Paiser", "Pak", "Pettigrew", "Quinn", "Quizoz", "Ramachandran", "Resnick", "Sagar", "Schickowski", "Schiebel", "Sellon", "Severson", "Shaffer", "Solberg", "Soloman", "Sonderling", "Soukup", "Soulis", "Stahl", "Sweeney", "Tandy", "Trebil", "Trusela", "Trussel", "Turco", "Uddin", "Uflan", "Ulrich", "Upson", "Vader", "Vail", "Valente", "Van Zandt", "Vanderpoel", "Ventotla", "Vogal", "Wagle", "Wagner", "Wakefield", "Weinstein", "Weiss", "Woo", "Yang", "Yates", "Yocum", "Zeaser", "Zeller", "Ziegler", "Bauer", "Baxster", "Casal", "Cataldi", "Caswell", "Celedon", "Chambers", "Chapman", "Christensen", "Darnell", "Davidson", "Davis", "DeLorenzo", "Dinkins", "Doran", "Dugelman", "Dugan", "Duffman", "Eastman", "Ferro", "Ferry", "Fletcher", "Fietzer", "Hylan", "Hydinger", "Illingsworth", "Ingram", "Irwin", "Jagtap", "Jenson", "Johnson", "Johnsen", "Jones", "Jurgenson", "Kalleg", "Kaskel", "Keller", "Leisinger", "LePage", "Lewis", "Linde", "Lulloff", "Maki", "Martin", "McGinnis", "Mills", "Moody", "Moore", "Napier", "Nelson", "Norquist", "Nuttle", "Olson", "Ostrander", "Reamer", "Reardon", "Reyes", "Rice", "Ripka", "Roberts", "Rogers", "Root", "Sandstrom", "Sawyer", "Schlicht", "Schmitt", "Schwager", "Schutz", "Schuster", "Tapia", "Thompson", "Tiernan", "Tisler" ]
var portfolios = ["Summer", "Custom", "Business", "Matrix", "Mozaik"];
var type = ["SME"];
var regionalManager = ["Grad Beograd", "Južnobački okrug", "Nišavski okrug"];
var state = ["Open", "Closed", "Waiting for approval"];
//var status = ["Won", "Lost"];
var status = ["Draft", "Prepared", "Sent", "Won", "Lost", "Canceled"];

function randomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  }

export const dataTableOffers = () => {
    let offers = [];
    for (var i = 0; i < 500; i++) {
        offers.push({
            customer:{ name: firstName[Math.floor(Math.random() * firstName.length)] + " " + lastName[Math.floor(Math.random() * lastName.length)] },
            portfolio: {
                type: type[Math.floor(Math.random() * type.length)],
                name: portfolios[Math.floor(Math.random() * portfolios.length)]
            },
            createdBy: lastName[Math.floor(Math.random() * lastName.length)],
            regionalManager: regionalManager[Math.floor(Math.random() * regionalManager.length)], 
            createdAt: randomDate(new Date(2020, 1, 1), new Date()),
            state: state[Math.floor(Math.random() * state.length)],
            status: status[Math.floor(Math.random() * status.length)]
        })
    }
    return offers
}

export const matrixMock = {
    name: "matrixMock",
    type: "row",
    rowNo: 2,
    vector: null,
    columns: [
        {
            label: "brojevi",
            values: [
                {
                    valueType: "number",
                    enumName: null,
                    valueObj: null,
                    valueString: null,
                    valueBool: null,
                    valueNumber: 1,
                    valueEnum: null,
                    valueRange: null,
                },
                {
                    valueType: "number",
                    enumName: null,
                    valueObj: null,
                    valueString: null,
                    valueBool: null,
                    valueNumber: 2,
                    valueEnum: null,
                    valueRange: null,
                },
            ],
        },
        {
            label: "tekst",
            values: [
                {
                    valueType: "string",
                    enumName: null,
                    valueObj: null,
                    valueString: "nekaj prvo",
                    valueBool: null,
                    valueNumber: null,
                    valueEnum: null,
                    valueRange: null,
                },
                {
                    valueType: "string",
                    enumName: null,
                    valueObj: null,
                    valueString: "nekaj drugo",
                    valueBool: null,
                    valueNumber: null,
                    valueEnum: null,
                    valueRange: null,
                },
            ],
        },
        {
            label: "range",
            values: [
                {
                    valueType: "range",
                    enumName: null,
                    valueObj: null,
                    valueString: null,
                    valueBool: null,
                    valueNumber: 980,
                    valueEnum: null,
                    valueRange: {
                      minVal: 950,
                      minIncluded: false,
                      maxVal: 1000,
                      maxIncluded: true
                    },
                },
                {
                    valueType: "range",
                    enumName: null,
                    valueObj: null,
                    valueString: null,
                    valueBool: null,
                    valueNumber: 1025,
                    valueEnum: null,
                    valueRange: {
                      minVal: 1000,
                      minIncluded: false,
                      maxVal: 1050,
                      maxIncluded: true
                    },
                },
            ],
        },
    ],
};
